import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'src/utils/AxiosConfig';

// ** Fetch daily_works
export const getDailyWorks = createAsyncThunk('appDailyWorks/getDailyWorks', async (params) => {
  const response = await axios.get('/api/daily_works', { params })
  return response.data
})

// ** Fetch getDailyWorksByDate
export const getDailyWorksByDate = createAsyncThunk('appDailyWorks/getDailyWorksByDate', async (params) => {
  const response = await axios.get('/api/daily_works/copy', { params })
  return response.data
})

// ** Fetch single User
export const getSingleDailyWorks = createAsyncThunk(
  'appDailyWorks/getSingleDailyWorks', 
  async ({ id, work_date }) => { // Destructure id and work_date from the payload
      const response = await axios.get(`/api/daily_works/${id}?work_date=${work_date}`);
      return response.data;
  }
);

// ** Add User
export const addDailyWorks = createAsyncThunk(
  'appDailyWorks/addDailyWorks', 
  async (data, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/api/daily_works', { ...data })
      return response.data
    } catch (error) {
      // Reject with the error message or any other error details you want
      return rejectWithValue(error.response ? error.response.data : error.message)
    }
  }
)

export const updateDailyWorks = createAsyncThunk(
  'appDailyWorks/updateDailyWorks', 
  async ({ id, ...data}, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(`/api/daily_works/${id}`, { ...data })
      return response.data
    } catch (error) {
      // Reject with the error message or any other error details you want
      return rejectWithValue(error.response ? error.response.data : error.message)
    }
  }
)

// ** Delete User
export const deleteData = createAsyncThunk('appDailyWorks/deleteData', async (id,  { getState, dispatch }) => {
  const response = await axios.delete(`/api/daily_works/${id}`)
  dispatch(getDailyWorks(getState().user.params)) // Refresh user list after deletion
  return response.data
})


export const deleteSingleData = createAsyncThunk('appDailyWorks/deleteSingleData', async (id,  { getState, dispatch }) => {
  const response = await axios.delete(`/api/daily_work_tasks/${id}`)
  dispatch(getDailyWorks(getState().user.params)) // Refresh user list after deletion
  return response.data
})

export const appDailyWorksSlice = createSlice({
  name: 'appDailyWorks',
  initialState: {
    singleData: {},   // Data for a single user
    data: [],         // Data for a list of daily_works
    total: 0,
    params: {},
    allData: [],      // (Optional) Store all user data if needed
    status: 'idle',
    message:null,
    errors: null
  },
  reducers: {
    resetSingleUser: (state) => {
      state.singleData = {}; // Reset single user data
    },
    resetStateIdele: (state) => {
      state.status = 'idle'; // Reset single user data
    }
  },
  extraReducers: (builder) => {
    // ** Fetch Multiple daily_works
    builder
      .addCase(getDailyWorks.pending, (state) => {
        state.status = 'loading';
        state.message = null;
        state.errors = null;
      })
      .addCase(getDailyWorks.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload.data;
        state.total = action.payload.total;
        state.params = action.payload.params;
      })
      .addCase(getDailyWorks.rejected, (state, action) => {
        state.status = 'failed';
        state.message = action.payload?.message || null;
        state.errors = action.payload?.errors || null;
      })

      builder
      .addCase(getDailyWorksByDate.pending, (state) => {
        state.status = 'loading';
        state.message = null;
        state.errors = null;
      })
      .addCase(getDailyWorksByDate.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload.data;
        state.total = action.payload.total;
        state.params = action.payload.params;
      })
      .addCase(getDailyWorksByDate.rejected, (state, action) => {
        state.status = 'failed';
        state.message = action.payload?.message || null;
        state.errors = action.payload?.errors || null;
      })
  
    // ** Add User
    builder
      .addCase(addDailyWorks.pending, (state) => {
        state.status = 'loading';
        state.message = null;
        state.errors = null;
      })
      .addCase(addDailyWorks.fulfilled, (state) => {
        state.status = 'Registration succeeded';
      })
      .addCase(addDailyWorks.rejected, (state, action) => {
        state.status = 'failed';
        state.message = action.payload.message;
        state.errors = Object.values(action.payload.errors).flat();
      });
  
    // ** Update User
    builder
      .addCase(updateDailyWorks.pending, (state) => {
        state.status = 'loading';
        state.message = null;
        state.errors = null;
      })
      .addCase(updateDailyWorks.fulfilled, (state) => {
        state.status = 'Update succeeded';
      })
      .addCase(updateDailyWorks.rejected, (state, action) => {
        state.status = 'failed';
        state.message = action.payload?.message;
        state.errors = action.payload?.errors;
      });
  
    
    // ** Fetch Single User
    builder
      .addCase(getSingleDailyWorks.pending, (state) => {
        state.status = 'loading';
        state.message = null;
        state.errors = null;
      })
      .addCase(getSingleDailyWorks.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.singleData = action.payload.data;
      })
      .addCase(getSingleDailyWorks.rejected, (state, action) => {
        state.status = 'failed';
        state.message = action.payload?.message;
        state.errors = action.payload?.errors;
      });
  
    // ** Delete All Data
    builder
      .addCase(deleteData.pending, (state) => {
        state.status = 'loading';
        state.message = null;
        state.errors = null;
      })
      .addCase(deleteData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload.data;
        state.total = action.payload.total;
        state.params = action.payload.params;
      })
      .addCase(deleteData.rejected, (state, action) => {
        state.status = 'failed';
        state.message = action.payload.message;
        state.errors = action.payload.errors;
      });

      // ** Delete Single Data
    builder
    .addCase(deleteSingleData.pending, (state) => {
      state.status = 'loading';
      state.message = null;
      state.errors = null;
    })
    .addCase(deleteSingleData.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.data = action.payload.data;
      state.total = action.payload.total;
      state.params = action.payload.params;
    })
    .addCase(deleteSingleData.rejected, (state, action) => {
      state.status = 'failed';
      state.message = action.payload?.message;
      state.errors = action.payload?.errors;
    });
  }
  
})

export const { resetSingleUser, resetStateIdele } = appDailyWorksSlice.actions;

export default appDailyWorksSlice.reducer
